// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 662) return "static/chunks/662-82aeec91f408b731.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "8453b8489f357d53" + ".js";
};